module.exports = __webpack_public_path__ + "static/media/search-icon-black-small.47b704ac.svg";